import KT01BaseLayout from 'general/components/BaseLayout/KT01BaseLayout';
import AppColors from 'general/constants/AppColors';
import UIHelper from 'general/helpers/UIHelper';
import useRouter from 'hooks/useRouter';

function UnderDevelopmentView() {
  const router = useRouter();
  return (
    <KT01BaseLayout>
      <div className="px-4">
        {UIHelper.buildCard(
          <div
            className="d-flex flex-column align-items-center justify-content-center py-10"
            style={{ minHeight: '60vh' }}
          >
            <i
              className="fa-regular fa-screwdriver-wrench"
              style={{ fontSize: 64, color: AppColors.gray[300] }}
            />
            <p
              className="mt-6 mb-2"
              style={{ fontSize: 20, fontWeight: 700, color: AppColors.gray[700] }}
            >
              Tính năng này đang trong quá trình phát triển
            </p>
            <p style={{ fontSize: 14, color: AppColors.gray[500] }}>
              Vui lòng quay lại sau.
            </p>
            <button
              className="btn btn-light-success mt-4"
              onClick={() => router.navigate(-1)}
            >
              Quay lại
            </button>
          </div>,
          false,
          false,
          true
        )}
      </div>
    </KT01BaseLayout>
  );
}

export default UnderDevelopmentView;
